import { render, staticRenderFns } from "./ModalExclusao.vue?vue&type=template&id=2f75390c"
import script from "./ModalExclusao.vue?vue&type=script&lang=js"
export * from "./ModalExclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports